<!--支付账户开户审核-->
<template>
  <div>
    <e-dialog
      :dialog-title="title"
      :center-dialog-visible="visible"
      popup-width="800px"
      subBtn="审核"
      @resetPopupData="handleViewClose"
      @submitPopupData="dealData"
      :onlyShowCancel="showCloseBtn"
    >
      <div class="body-content" v-loading="loading">
        <el-card header="" class="small-card">
          <el-descriptions :column="2" size="mini" border>
            <el-descriptions-item label="公司名称" span="2"><span :class="{'red-color': classNameFilter('companyName')}" class="start-show">{{auditDetail.companyName}}</span></el-descriptions-item>
            <el-descriptions-item label="行政区域" span="2">
              <div class="start-show">
                <span :class="{'red-color': classNameFilter('province')}">{{auditDetail.province}}</span>
                <span :class="{'red-color': classNameFilter('city')}">{{auditDetail.city}}</span>
                <span :class="{'red-color': classNameFilter('district')}">{{auditDetail.district}}</span>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="营业执照注册号">
              <span class="start-show">{{auditDetail.businessLicenseNo}}</span></el-descriptions-item>
            <el-descriptions-item label="证件有效期">
              <div class="start-show" >
                 <span>{{getAttachmentInfo('MRC')?.certificateLongValid === 1
              ? '长期有效'
              : getAttachmentInfo('MRC')?.certificateEndTime}}</span>
                <el-button class="view-button" type="primary" size="mini" @click="previewFile('MRC')">查看</el-button>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="注册地址" span="2"><span class="start-show" :class="{'red-color': classNameFilter('regCity')}">{{auditDetail.regCity}}</span></el-descriptions-item>
            <el-descriptions-item label="申请人姓名" span="2">
              <span slot="label">
                    <span class="red-color">*</span><span>申请人姓名:</span>
              </span>
              <div class="start-show" >
                  <el-input v-model="modifyData.creatorRealName" placeholder="请输入申请人姓名" v-if="canModify === 1"
                            style="width: 240px;"></el-input>
                  <span v-else>{{modifyData.creatorRealName}}</span>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="申请人证件号" span="2">
              <span slot="label">
                    <span class="red-color">*</span><span>申请人证件号:</span>
              </span>
              <div class="flex-a-c start-show">
                <el-input v-model="modifyData.certNo" placeholder="请输入申请人证件号" v-if="canModify === 1" style="width: 240px;"></el-input>
                <span  v-else>{{modifyData.certNo}}</span>
                <el-button class="view-button" style="height: 22px;" type="primary" size="mini"
                           v-if="modifyData.certAttachPath"
                           @click="getPayCenterFile(modifyData.certAttachPath,modifyData.certAttachName)">查看</el-button>
                <el-button class="view-button start-show" type="primary" size="mini"
                           v-if="!modifyData.certAttachPath"
                           @click="handleUploadFile(1)">添加</el-button>
                <el-button class="view-button start-show" type="secondary" size="mini"
                           v-if="canModify === 1"
                           @click="handleDel(1)">删除</el-button>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="证件有效期" span="2">
               <span slot="label">
                    <span class="red-color">*</span><span>证件有效期:</span>
              </span>
              <div v-if="canModify === 1" class="start-show">
                <el-date-picker
                        style="width: 240px;margin-right: 10px"
                        v-model="modifyData.certAttachTime"
                        class="form-item4"
                        type="datetimerange"
                        placeholder="请选择"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        :disabled="modifyData.certAttachLongValid"
                ></el-date-picker>
                <el-checkbox v-model="modifyData.certAttachLongValid" class="is-longtime">长期有效</el-checkbox>
              </div>
              <div class="start-show" v-else>
                <span>{{ modifyData.certAttachLongValid ? '长期有效' : modifyData.certificateBeginTime + ' - '+ modifyData.certificateEndTime}}</span>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="易派客平台用户名" span="2">
              <span class="start-show" :class="{'red-color': classNameFilter('creator')}">{{auditDetail.creator}}</span>
            </el-descriptions-item>
            <el-descriptions-item label="管理员支付授权书" span="2">
               <span slot="label">
                    <span class="red-color">*</span><span>管理员支付授权书:</span>
              </span>
              <div class="start-show">
                <el-button class="view-button start-show" type="primary" size="mini"
                           v-if="modifyData.authAttachPath"
                           @click="getPayCenterFile(modifyData.authAttachPath,modifyData.authAttachName)">查看</el-button>
                <el-button class="view-button start-show" type="primary" size="mini"
                           v-if="!modifyData.authAttachPath"
                           @click="handleUploadFile(2)">添加</el-button>
                <el-button class="view-button start-show" type="secondary" size="mini"
                           v-if="canModify === 1"
                           @click="handleDel(2)">删除</el-button>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="法定代表人姓名"><span class="start-show" :class="{'red-color': classNameFilter('legalPerson')}">{{auditDetail.legalPerson}}</span></el-descriptions-item>
            <el-descriptions-item label="法定代表人证件号码">
              <div class="flex-a-c start-show">
                <span>{{certificateNo}}</span>
                <el-button class="view-button" type="primary" size="mini" @click="previewFile('LRC')">查看</el-button>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="法定代表人手机号码"><span class="start-show">{{auditDetail.legalPersonMobile}}</span></el-descriptions-item>
            <el-descriptions-item label="法定代表人证件类型"><span class="start-show">{{getCertificateTypeDesc(getAttachmentInfo('LRC')?.certificateType)}}</span></el-descriptions-item>
            <el-descriptions-item label="法定代表人证件有效期">
              <span class="start-show">{{getAttachmentInfo('LRC')?.certificateLongValid === 1
              ? '长期有效'
              : getAttachmentInfo('LRC')?.certificateEndTime}}</span></el-descriptions-item>
          </el-descriptions>
        </el-card>
        <el-card header="" class="small-card">
          <el-descriptions :column="2" size="mini" border>
            <el-descriptions-item label="银行账户户名" span="2"><span class="start-show"  :class="{'red-color': classNameFilter('bankAccountName')}">{{auditDetail.bankAccountName}}</span></el-descriptions-item>
            <el-descriptions-item label="银行账户账号"><span class="start-show"  :class="{'red-color': classNameFilter('bankAccount')}">{{auditDetail.bankAccount}}</span></el-descriptions-item>
            <el-descriptions-item label="开户银行行号"><span class="start-show"  :class="{'red-color': classNameFilter('bankCode')}">{{auditDetail.bankSerials}}</span></el-descriptions-item>
          </el-descriptions>
        </el-card>
      </div>
        <el-image ref="cFImg" :src="bigImageUrl" :preview-src-list="previewSrcList"
                  style="width: 0; height: 0"></el-image>
      <!--图片上传-->
      <upload-file-dialog
              :uploadFileVisible.sync="uploadFileVisible"
              v-if="uploadFileVisible"
              @handleConfirm="handleConfirm"
      />
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/components/common/e-dialog.vue';
import api from '@/modules/projectA/api/paymentAccount/index';
import uploadFileDialog from '../common/uploadFileDialog';
export default {
  name: 'AccountOpeningReview',
  components: {
    eDialog,
    uploadFileDialog
  },
  props: {
    title: {
      type: String,
      default: '账户信息'
    },
    visible: Boolean,
    id:'',
    canModify:{
      type:Number,
      default: 0
    },
  },
  data() {
    return {
      bigImageUrl: '',
      previewSrcList: [],
      fileFlag:0,
      uploadFileVisible:false,
      showCloseBtn:false,
      dialogPicUrl: '',
      formData: {
        auditStatus: '0',
      },
      certificateNo:'',
      modifyData:{
        id:'',
        memberId:'',
        companyId:'',
        creator:'',
        creatorRealName:'',//申请人姓名
        certNo:'',//身份证件号码
        certAttachBeginTime:'',//管理员身份证有效期开始时间
        certAttachEndTime:'',//管理员身份证有效期结束时间
        certAttachLongValid:false,//管理员证件有效期
        certAttachTime:'',
        authAttachName:'',// 管理员支付平台授权书附件名称
        authAttachPath:'',//管理员支付平台授权书附件路径
        certAttachName:'',//申请人身份证附件名称
        certAttachPath:'',//申请人身份证附件路径
      },
      loading: false,
      optType: '',
      rowData: {},
      auditDetail: {}, // 申请详情
      certificateTypeList: [
        { itemCode: 0, itemDisp: '居民身份证' },
        { itemCode: 1, itemDisp: '武装警察身份证' },
        { itemCode: 2, itemDisp: '护照' },
        { itemCode: 3, itemDisp: '军人身份证' },
        { itemCode: 4, itemDisp: '港澳居民往来内地通行证' },
        { itemCode: 5, itemDisp: '台湾居民往来大陆通行证' },
        { itemCode: 6, itemDisp: '户口簿' },
        { itemCode: 7, itemDisp: '临时居民身份证' }
      ],
      userData: [],
      opMode: null
    };
  },
  computed: {
    // 表单验证规则
    rules() {
      return {
        auditStatus: [{ required: true, message: '请选择', trigger: 'change' }],
      };
    },
  },
  methods: {
    handleDel(flag){
      if(flag === 2){
        this.modifyData.authAttachName = '';
        this.modifyData.authAttachPath = ''
      }else{
        this.modifyData.certAttachName = '';
        this.modifyData.certAttachPath = '';
        this.modifyData.certNo = '';
      }
    },
    handleConfirm(fileData){
      const {fileName,url} = fileData;
      if(this.fileFlag === 1){//申请人身份证附件
        this.modifyData.certAttachName = fileName || '';
        this.modifyData.certAttachPath = url || '';
      }else if(this.fileFlag === 2){//管理员支付授权书
        this.modifyData.authAttachName = fileName || '';
        this.modifyData.authAttachPath = url || '';
      }
      this.uploadFileVisible = false;
    },
    //操作上传      2 :管理员支付授权书; 1 :
    handleUploadFile(flag){
      this.uploadFileVisible = true;
      this.fileFlag = flag;
    },
    dealData(){
      if(!this.modifyData.creatorRealName){
        this.$message.warning('申请人姓名不能为空');
        return false;
      }
      if(!this.modifyData.certAttachPath){
        this.$message.warning('申请人证件号附件不能为空');
        return false;
      }
      if(!this.modifyData.certAttachTime && !this.modifyData.certAttachLongValid){
        this.$message.warning('证件有效期不能为空');
        return false;
      }
      if(!this.modifyData.authAttachPath){
        this.$message.warning('管理员支付授权书附件不能为空');
        return false;
      }
      if (this.modifyData.certAttachTime.length > 0) {
        this.modifyData.certAttachBeginTime = this.modifyData.certAttachTime[0];
        this.modifyData.certAttachEndTime = this.modifyData.certAttachTime[1];
      }
      this.modifyData.certAttachLongValid = Number(this.modifyData.certAttachLongValid);


      this.reApplyModify();
    },
    async reApplyModify(){

      const res = await api.reApplyModify(this.modifyData);
      if(res.success){
        this.$message.success('变更成功');
        this.$emit('update:visible', false);
      }
    },
    async modifyDetail(){
      const res = await api.modifyDetail({id:this.id});
      if(res.success){
        this.auditDetail = res.data;
        this.opMode = res.data.opMode;
        this.modifyData.id = this.id;
        this.modifyData.memberId = res.data.memberId;
        this.modifyData.companyId  = res.data.companyId;
        this.modifyData.creator = res.data.creator;
        this.modifyData.creatorRealName = this.auditDetail.creatorRealName;//申请人姓名
        this.modifyData.certNo = this.getAttachmentInfo('AC')?.certificateNo;//申请人证件号
        this.modifyData.certificateBeginTime = this.getAttachmentInfo('AC')?.certificateBeginTime;
        this.modifyData.certificateEndTime = this.getAttachmentInfo('AC')?.certificateEndTime;
        this.modifyData.certAttachTime = [this.modifyData.certificateBeginTime, this.modifyData.certificateEndTime];//证件有效期
        this.modifyData.certAttachLongValid = this.getAttachmentInfo('AC')?.certificateLongValid ? true : false; //证件有效期
        this.modifyData.certAttachName = this.getAttachmentInfo('AC')?.attachName;//申请人身份证附件名称
        this.modifyData.certAttachPath = this.getAttachmentInfo('AC')?.attachPath;//申请人身份证附件路径
        this.modifyData.authAttachName = this.getAttachmentInfo('AA')?.attachName;//管理员支付授权书名字
        this.modifyData.authAttachPath = this.getAttachmentInfo('AA')?.attachPath;//管理员支付授权书路径

        this.certificateNo = this.getAttachmentInfo('LRC').certificateNo;//
      }
    },
    //关闭弹窗
    handleViewClose() {
      this.$emit('update:visible',false);
    },
    // 获取证件类型描述
    getCertificateTypeDesc(certificateType) {
      if(!certificateType){
        return '居民身份证'
      }else{
        return this.certificateTypeList?.find(
                (item) => item.itemCode === certificateType
        )?.itemDisp;
      }
    },
    // 查看
    async previewFile(type, list) {
      const file = this.getAttachmentInfo(type, list);
      if (!file?.attachPath) {
        this.$message.info('暂无可查看文件');
        return;
      }
      this.getPayCenterFile(file?.attachPath,file.attachName);
    },
    //预览
    async getPayCenterFile(filePath,attachName){
      const res = await api.getPayCenterFile({filePath: filePath});
      if (res.success) {
        let features = 'height=470,width=820,top=180,left=520,toolbar=no,scrollbars=yes,menubar=no,location=no,status=no';
        const viewImageUrl = this.$router.resolve({ path: '/viewImage' }).href;
        const fileType = attachName.substr(attachName?.lastIndexOf('.') + 1);
        if (fileType?.toLowerCase() !== 'pdf') {
          // 预览图片
          this.bigImageUrl = res.data;
          this.previewSrcList = [res.data];
          this.$nextTick(() => {
            this.$refs.cFImg.showViewer = true;
          });
        } else {
          // 预览pdf
          window.open(res.data, '_blank', features);
        }
      }
    },

    // 获取附件信息
    getAttachmentInfo(type, list) {
      const sourceData = list ?? this.auditDetail?.settleAccountAttachTempList;
      return sourceData?.find((item) => item.attachType === type);
    },
    classNameFilter(paramsName) {
      return this.auditDetail?.dif?.includes(paramsName);
    },
    classNameFilterByAttachType(attachType) {
      let paramsName = attachType;
      if (this.getAttachmentInfo('LRC')?.certificateLongValid === 1) {
        paramsName = paramsName + '.certificateLongValid'
      } else {
        paramsName = paramsName + '.certificateEndTime'
      }
      return this.auditDetail?.dif?.includes(paramsName);
    }
  },
  mounted() {
    this.modifyDetail();
    this.showCloseBtn = this.canModify ? false : true;
  }
};
</script>

<style scoped lang="scss">
.start-show{
  display: flex;
  margin-left: 4px;
  align-items: center;
}
::v-deep .table{
  text-align: start;
}
::v-deep .el-descriptions-item__label.is-bordered-label{
  background-color: #f5f7fa;
  color: #909399;
  font-size: 12px;
  font-weight: 400;
  border:1px solid #EBEEF5 ;
  line-height: 26px;
 }
::v-deep .small-card {
  margin-bottom: 10px;

  .el-card__body {
    padding: 5px;
  }
}

::v-deep .el-card__header {
  //background: #f1f4f6;
  padding: 5px 20px !important;
}
::v-deep .el-descriptions-item__label.is-bordered-label {
  width: 153px;
}
.view-button {
  padding: 4px 8px;
  margin-left: 10px;
}
.red-color {
  color: #f00;
}
</style>
